import { faEdit, faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type CellContext } from '@tanstack/react-table';

import { SectionBlockHead } from 'src/registry/components/blocks/SectionBlock';
import { Button } from 'src/registry/ui/Button';

interface CustomContext<TData, TValue> extends CellContext<TData, TValue> {
    showActions: boolean;
    editCallback: (planId: number) => void;
    deleteCallback: (planId: number) => void;
}
export function CellCustomIdActions<TData, TValue>({
    cell: _,
    row,
    table,
    getValue,
    editCallback,
    deleteCallback,
    showActions,
}: CustomContext<TData, TValue>) {
    const { pageIndex, pageSize } = table.getState().pagination;
    const rowIndex = row.index + 1 + pageIndex * pageSize;
    const value = getValue() as number;
    return (
        <div className="flex flex-1 items-center justify-between">
            <SectionBlockHead>{value ? value.toString() : rowIndex}</SectionBlockHead>
            {showActions && (
                <div className="flex gap-1">
                    <Button
                        variant="ghost"
                        className="size-8 p-0"
                        onClick={(e) => {
                            e.stopPropagation();
                            editCallback(value);
                        }}
                    >
                        <FontAwesomeIcon icon={faEdit} />
                    </Button>
                    <Button
                        variant="ghost"
                        className="size-8 p-0"
                        onClick={(e) => {
                            e.stopPropagation();
                            deleteCallback(value);
                        }}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </Button>
                </div>
            )}
        </div>
    );
}
